export default function() {
  return new Worker(__webpack_public_path__ + "search.worker-d970194cae16cfe93ee7.worker.js");
}
